import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Device } from '@app/shared/models/device';
import { Logo } from '@app/shared/models/logo';
import { Team } from '@app/shared/models/team';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import * as fromRoot from './../../../../reducers';
import { ViewerActions } from './../../actions';
import * as fromViewer from './../../reducers/viewer.reducer';
import { ResolveDomainService } from '@app/core/services/resolvers/resolve-domain.service';

@Component({
  selector: 'app-modal-transfer-password',
  templateUrl: './modal-transfer-password.component.html',
  styleUrls: ['./modal-transfer-password.component.scss']
})

export class ModalTransferPasswordComponent implements OnInit, OnDestroy {

  menuDisplayed$: Observable<boolean>;
  selectedTeam$: Observable<Team>;
  hasToken$: Observable<boolean>;

  unlockLoading$: Observable<boolean>;
  unlockError$: Observable<any>;
  previewLoaded$: Observable<boolean>;

  logo: Logo;
  device: Device;
  transferId: string;
  passwordForm: FormGroup;
  invalidPassword = false;
  errorMessage: string;
  hidePassword = true;
  isPremium: boolean;
  submitted = false;
  subscriptions: Subscription[] = [];

  constructor(
    private readonly store$: Store<fromRoot.State & fromViewer.State>,
    private resolveDomainService: ResolveDomainService,
    private ref: DialogRef,
    private router: Router
  ) {
    this.device = this.ref.data.device;
    this.transferId = this.ref.data.transferId;
    this.unlockLoading$ = this.store$.select(fromViewer.getPreviewLoading);

    this.previewLoaded$ = this.store$.select(fromViewer.getPreviewLoaded);

    this.unlockError$ = this.store$.select(fromViewer.getPreviewUnlockError);

    this.menuDisplayed$ = this.store$.select(fromViewer.getMenuDisplayed);
    this.selectedTeam$ = this.store$.select(fromRoot.getActiveTeam);
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);

    this.subscriptions.push(
      this.resolveDomainService.resolve().subscribe((res) => {
        this.logo = res.domain.logo;
        this.isPremium = !!res.domain.team;
      }),
      this.unlockLoading$.subscribe((loading => this.submitted = loading)),
      this.previewLoaded$.pipe(first(loaded => loaded)).subscribe(() => this.closeModal())
    );
  }

  ngOnInit() {
    this.passwordForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
    });
  }


  ngOnDestroy() {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }

  onSubmit() {
    this.errorMessage = null;
    if (!this.submitted && this.passwordForm.valid) {
      this.submitted = true
      const password = this.passwordForm.value.password;
      this.store$.dispatch(ViewerActions.LoadPreview({ transferId: this.transferId, password }));
    }
  }

  onGoToUploader(): void {
    this.closeModal();
    this.router.navigateByUrl('/');
  }

  closeModal(): void {
    this.ref.close();
  }

  onToggleMenu(event) {
    this.store$.dispatch(ViewerActions.ToggleMenu({ menuDisplayed: event.toggled }));
    event.event?.stopPropagation();
    return false;
  }
}
